import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isClose: false,
    dropped: null,
    selected: null,
    isMobileOpen: false,
}

const sidebarSlice = createSlice({
    name: "sidebar",
    initialState,
    reducers: {
        toggleSidebarState: (state) => {
            state.isClose = !state.isClose
        },
        setDropped: (state, action) => {
            state.dropped = action.payload || null
        },
        selectPage: (state, action) => {
            state.selected = action.payload || null
        },
        toggleMobileSidebar: (state) => {
            state.isMobileOpen = !state.isMobileOpen
        },
        closeMobileSidebar: (state) => {
            state.isMobileOpen = false
        }
    }
})

export const selectSidebarIsClose = (state) => state.sidebar.isClose;
export const selectSidebarDropped = (state) => state.sidebar.dropped;
export const selectSidebarSelected = (state) => state.sidebar.selected;
export const selectSidebarIsMobileOpen = (state) => state.sidebar.isMobileOpen;

export const { toggleSidebarState, setDropped, selectPage, toggleMobileSidebar, closeMobileSidebar } = sidebarSlice.actions;
export default sidebarSlice.reducer;